// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2f5VF","col":"Table_col__2p-4P","fulfillmentStatus":"Table_fulfillmentStatus__2NJHe","emailCol":"Table_emailCol__2SuVp"};